import logo from "../assets/VOPA-sm.png";

export const HomeContainer = () => {
  return (
    <div className="white-wrapper column">
      <div className="pl-xl py bg-white">
        <img src={logo} alt="logo" className="" width="160px" />{" "}
      </div>
      <div className="img-background">
        <div className="overlay"></div>
        <div className="content-wrapper">
          <div className="content grid columns-2 columns-1--md">
            <div className="bg-highlight p-lg">
              <h1 className="text-main text-center">Fejl/mangel system</h1>
              <p className="text-main">
                Anvend dit fremsendte individuelle link/QR-kode for at komme til
                din side.
              </p>
            </div>
            <div className="bg-main p-lg">
              <p>
                <span className="text-bold">VOPA Rådgivning</span>
                <br />
                Vester Voldgade 106
                <br />
                1552 København V<br />
                CVR: 36450258
              </p>
              <p>
                Telefon: 93 95 64 02
                <br />
                Email: bg@vopa.dk
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center p-lg bg-white stretch">
        <img src={logo} alt="logo" className="" width="160px" />{" "}
        <div className="mt">
          <a href="/admin">Admin login</a>
        </div>
      </div>
      <div className="footer">
        <span>© Copyright - VOPA Rådgivning</span>
      </div>
    </div>
  );
};
